var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "안전 의견 게시판 기본정보" },
            },
            [
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                  },
                  [
                    _c("c-text", {
                      attrs: {
                        required: "",
                        editable: _vm.editable,
                        label: "제목",
                        name: "boardTitle",
                      },
                      model: {
                        value: _vm.data.boardTitle,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "boardTitle", $$v)
                        },
                        expression: "data.boardTitle",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                  },
                  [
                    _c("c-datepicker", {
                      attrs: {
                        required: "",
                        editable: _vm.editable,
                        label: "의견게시일",
                        name: "boardDate",
                      },
                      model: {
                        value: _vm.data.boardDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "boardDate", $$v)
                        },
                        expression: "data.boardDate",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                  },
                  [
                    _c("c-plant", {
                      attrs: {
                        required: "",
                        editable: _vm.editable,
                        type: "edit",
                        name: "plantCd",
                      },
                      model: {
                        value: _vm.data.plantCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "plantCd", $$v)
                        },
                        expression: "data.plantCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                  },
                  [
                    _c("c-textarea", {
                      attrs: {
                        editable: _vm.editable,
                        rows: 4,
                        label: "의견게시내용",
                        name: "boardContents",
                      },
                      model: {
                        value: _vm.data.boardContents,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "boardContents", $$v)
                        },
                        expression: "data.boardContents",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                  },
                  [
                    _c("c-upload", {
                      attrs: {
                        attachInfo: _vm.attachInfo,
                        editable: _vm.editable,
                        label: "개선/확보관련 파일",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c(
            "c-table",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.popupParam.boardId,
                  expression: "popupParam.boardId",
                },
              ],
              ref: "table",
              attrs: {
                isTitle: "",
                title: "댓글 목록",
                columns: _vm.grid.columns,
                gridHeight: _vm.grid.height,
                data: _vm.data.policyCommentModelList,
                filtering: false,
                columnSetting: false,
                isExcelDown: false,
                usePaging: false,
                noDataLabel: "댓글을 추가하세요.",
                hideBottom: true,
                editable: _vm.editable,
              },
              scopedSlots: _vm._u([
                {
                  key: "customArea",
                  fn: function ({ props, col }) {
                    return [
                      col.name === "policyComments"
                        ? [
                            _vm.$store.getters.user.userId ===
                            props.row.regUserId
                              ? _c("c-textarea-column", {
                                  attrs: {
                                    editable: _vm.editable,
                                    props: props,
                                    col: col,
                                  },
                                  model: {
                                    value: props.row["policyComments"],
                                    callback: function ($$v) {
                                      _vm.$set(props.row, "policyComments", $$v)
                                    },
                                    expression: "props.row['policyComments']",
                                  },
                                })
                              : _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(props.row["policyComments"]) +
                                      " "
                                  ),
                                ]),
                          ]
                        : _vm._e(),
                      col.name === "complete"
                        ? [
                            _c("q-btn", {
                              staticClass: "glossy",
                              attrs: {
                                round: "",
                                size: "sm",
                                editable: _vm.editable,
                                disable:
                                  _vm.$store.getters.user.userId !==
                                  props.row.regUserId,
                                color: "blue-6",
                                icon: "save",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.saveComment(props.row)
                                },
                              },
                            }),
                            _c("q-btn", {
                              staticClass: "glossy",
                              attrs: {
                                round: "",
                                size: "sm",
                                editable: _vm.editable,
                                disable:
                                  _vm.$store.getters.user.userId !==
                                  props.row.regUserId,
                                color: "red",
                                icon: "delete",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.removeComment(props.row)
                                },
                              },
                            }),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              showLoading: false,
                              label: "댓글추가",
                              icon: "add",
                            },
                            on: { btnClicked: _vm.add },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
        ],
        1
      ),
      _c("div", { staticClass: "popup-bottom-bar" }, [
        _c(
          "div",
          { staticClass: "popup-bottom-bar-btngroup" },
          [
            _c(
              "q-btn-group",
              { attrs: { outline: "" } },
              [
                _vm.popupParam.boardId && _vm.editable
                  ? _c("c-btn", {
                      attrs: {
                        flat: "",
                        label: "삭제",
                        icon: "delete_forever",
                      },
                      on: { btnClicked: _vm.removeData },
                    })
                  : _vm._e(),
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editable,
                      expression: "editable",
                    },
                  ],
                  attrs: {
                    flat: "",
                    url: _vm.saveUrl,
                    isSubmit: _vm.isSave,
                    param: _vm.data,
                    mappingType: _vm.mappingType,
                    label: "저장",
                    icon: "save",
                  },
                  on: {
                    beforeAction: _vm.saveData,
                    btnCallback: _vm.saveCallback,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "popup-bottom-bar-close" },
          [
            _c("q-btn", {
              attrs: { flat: "", color: "gray", icon: "arrow_back" },
              on: { click: _vm.closePopUps },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }